import React, { useEffect, useRef, useState, useMemo } from "react";
import { fetchCenters, fetchWisdomDetailsData } from "../services/dashboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faPrint } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../context/AuthContext";
import LoadingScreen from "../components/LoadingScreen";
import { CURRENT_YEAR } from "../constants/constants";
import { buildOrgStandards, buildOrgSubStandards } from "../constants/wisdomBenchmarks";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
// Images
import WatomsDashboardFormDetails from "components/watoms/MainDashboard/WatomsDashboardFormDetails";
import { fetchWisdomSpecializations, fetchWisdomStages, fetchWisdomSubjects } from "services/wisdom/wisdomData";
import toast from "react-hot-toast";
import WisdomDashboardSubDataDetails from "components/wisdom/WisdomDashboardSubDataDetails";
import { fetchWisdomDashboardGeneralInfoData, fetchWisdomEmployeesAbsence } from "services/wisdom/wisdomDashboard";
import UserProfileData from "components/ui/UserProfileData";
import ModelNaviagtionSideBar from "components/ui/ModelNavigationSideBar";
import WorkShopDetails from "components/ui/WorkShopDetails";
import TeachersDashboard from "components/dashboard/TeacherDashboard";
import CurriculumDashboard from "components/dashboard/CurriculumDashboard";
import EmployeeAbsneceDashboard from "components/ui/EmployeeAbsneceDashboard";
import ClassRoomDetailsDashboard from "components/ui/ClassRoomDetailsDashboard";
import { fetchAllClassRoomDetailsData } from "services/data";
import WCPDashboard from "components/dashboard/WCPDashboard";
import CroReport from "components/dashboard/CroReport";
import CroReport2 from "components/dashboard/CroReport2";
import WorkEnvDashboard from "components/dashboard/WorkEnvDashboard";
import EduEnvDashboard from "components/dashboard/EduEnvDashboard";
import ODBMDashboard from "components/dashboard/ODBMDashboard";
import StudentAttendanceDashboard from "components/dashboard/StudentAttendanceDashboard";
import WisdomDashboardNavbar from "components/navbars/WisdomDashboardNavbar";
import WisdomDashboardOrganizationOverview from "components/wisdom/dashboard/WisdomDashboardOrganizationOverview";
import WisdomDashboardGeneralInfo from "components/wisdom/dashboard/WisdomDashboardGeneralInfo";
import DashboardMiddleColumn from "components/dashboard/DashboardMiddleColumn";
import WisdomDashboardGeneralNumbers from "components/wisdom/dashboard/WisdomDashboardGeneralNumbers";
import DashboardBenchmarks from "components/dashboard/DashboardBenchmarks";

const WisdomDashboard = () => {
    // React Tools
    const pdfRef = useRef();
    const pdfRef2 = useRef();
    // Custom Tools
    const { userInfo } = useAuth();
    // State Variables
    const [wisdomData, setWisdomData] = useState([]);
    const [selectedCenter, setSelectedCenter] = useState(null);
    const [datasMonths, setDatasMonths] = useState([]);
    const [selectedOrgId, setSelectedOrgId] = useState("All");
    const [selectedMonth, setSelectedMonth] = useState({});
    const [selectedMonthIdx, setSelectedMonthIdx] = useState({});
    const [selectedOrg, setSelectedOrg] = useState(null);
    const [arrangedOrg, setArrangedOrg] = useState([]);
    const [arrangedOrgIdx, setArrangedOrgIdx] = useState(0);
    const [subDataDetails, setSubDataDetails] = useState("");
    const [year, setYear] = useState(CURRENT_YEAR);
    const [subDataStatus, setSubDataStatus] = useState(false);
    const [formDetails, setFormDetails] = useState("");
    const [selectedFormCode, setSelectedFormCode] = useState("");
    const [stages, setStages] = useState([]);
    const [selectedStage, setSelectedStage] = useState("");
    const [subjects, setSubjects] = useState([]);
    const [selectedSubject, setSelectedSubject] = useState("");
    const [specializations, setSpecializations] = useState([]);
    const [selectedSpecialization, setSelectedSpecialization] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [generalInfo, setGeneralInfo] = useState({});
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [showUserProfilePopup, setShowUserProfilePopup] = useState(false);
    const [selectedWorkshopId, setSelectedWorkshopId] = useState(null);
    const [showWorkShopPopup, setShowWorkShopPopup] = useState(false);
    const [selectedUserRole, setSelectedUserRole] = useState("");
    const [employeeAbsenceDashboardPopup, setEmployeeAbsenceDashboardPopup] = useState(false);
    const [employeesAbsence, setEmployeesAbsence] = useState([]);
    const [filteredEmployeesAbsence, setFilteredEmployeesAbsence] = useState([]);
    const [classRoomDetails, setClassRoomDetails] = useState([]);
    const [classRoomDetailsPopup, setClassRoomDetailsPopup] = useState(false);
    const [popupPage, setPopupPage] = useState("");
    const [odbmPage, setOdbmPage] = useState("");
    const [mainDataLoading, setMainDataLoading] = useState(true);
    const [subDataLoading, setSubDataLoading] = useState(true);

    // fetch wisdom dashboard data
    useEffect(() => {
        const loadData = async () => {
            try {
                const [
                    generalResponse, employeesAbsenceResponse, workshopResponse,
                    subjectResponse, stagesResponse, specializationResponse
                ] = await Promise.all([
                    fetchWisdomDashboardGeneralInfoData(),
                    fetchWisdomEmployeesAbsence(),
                    fetchAllClassRoomDetailsData(),
                    fetchWisdomSubjects(),
                    fetchWisdomStages(),
                    fetchWisdomSpecializations()
                ]);
                setGeneralInfo(generalResponse);
                setEmployeesAbsence(employeesAbsenceResponse);
                setClassRoomDetails(workshopResponse);
                setSubjects(subjectResponse);
                setStages(stagesResponse);
                setSpecializations(specializationResponse);
            } catch (error) {
                console.error('Error fetching the data:', error);
                toast.error('Error fetching the data please try again later');
            } finally {
                setSubDataLoading(false)
            }
        };

        loadData();
    }, []);

    // fetch watoms dashboard data 2
    useEffect(() => {
        const loadWisdomDetailedData = async () => {
            try {
                if (fromDate > toDate) {
                    toast.error("الرجاء اختيار تاريخ صحيح");
                    return;
                }

                setMainDataLoading(true);

                const response = await fetchWisdomDetailsData(year, {
                    stage: selectedStage,
                    subject: selectedSubject,
                    specialization: selectedSpecialization,
                    from: fromDate,
                    to: toDate,
                });
                console.log(response)
                setWisdomData(response);

            } catch (error) {
                console.error("❌ Error fetching Watoms Data:", error);
            } finally {
                setMainDataLoading(false);
            }
        };

        loadWisdomDetailedData();
    }, [
        year,
        selectedStage,
        selectedSubject,
        selectedSpecialization,
        fromDate,
        toDate,
    ]);

    // filter employees absence
    useEffect(() => {
        const filterEmployeesAbsence = () => {
            const filtering = employeesAbsence.filter(emp => {
                const absenceDate = new Date(emp.absence_date);

                const matchesOrg =
                    selectedOrgId === "All" ||
                    emp.employee.organization.id === Number(selectedOrgId);

                const matchesYear =
                    absenceDate.getFullYear() === Number(year);

                const matchesMonth =
                    absenceDate.getMonth() === selectedMonthIdx; // 0 = January

                return matchesOrg && matchesYear && matchesMonth;
            });

            setFilteredEmployeesAbsence(filtering);
        };

        filterEmployeesAbsence();
    }, [employeesAbsence, selectedOrgId, selectedMonthIdx, year]);

    // Filter subjects based on selected specialization
    const filteredSubjects = useMemo(() => {
        if (selectedSpecialization === "" || selectedSpecialization === "All") {
            return subjects;
        }

        const specialization = specializations.find(
            specialization =>
                specialization.id === Number(selectedSpecialization)
        );

        if (!specialization) {
            return [];
        }

        const subjectIds = specialization.subject.map(subject => subject.id);

        return subjects.filter(subject => subjectIds.includes(subject.id));
    }, [selectedSpecialization, specializations, subjects]);

    // Filter specializations based on selected subject
    const filteredSpecializations = useMemo(() => {
        if (selectedSubject === "" || selectedSubject === "All") {
            return specializations;
        }

        const subject = subjects.find(
            subject => subject.id === Number(selectedSubject)
        );

        if (!subject) {
            return [];
        }

        const specializationIds = subject.specializations.map(
            specialization => specialization.id
        );

        return specializations.filter(
            specialization => specializationIds.includes(specialization.id)
        );
    }, [selectedSubject, subjects, specializations]);

    // Filter stages based on the selected specialization OR subject
    const filteredStages = useMemo(() => {
        if (selectedSpecialization && selectedSpecialization !== "All") {
            const specialization = specializations.find(
                specialization =>
                    specialization.id === Number(selectedSpecialization)
            );

            if (!specialization) {
                return [];
            }

            const stageIds = specialization.stages.map(stage => stage.id);

            return stages.filter(stage => stageIds.includes(stage.id));
        }

        if (selectedSubject && selectedSubject !== "All") {
            const subject = subjects.find(
                subject => subject.id === Number(selectedSubject)
            );

            if (!subject) {
                return [];
            }

            const stageIds = subject.stages.map(stage => stage.id);

            return stages.filter(stage => stageIds.includes(stage.id));
        }

        return stages;
    }, [
        selectedSpecialization,
        selectedSubject,
        specializations,
        subjects,
        stages
    ]);

    const selectedMonthData = selectedOrg?.months?.[selectedMonthIdx];

    const orgStandards = useMemo(() => buildOrgStandards(selectedMonthData), [selectedMonthData]);

    const orgSubStandards = useMemo(() => buildOrgSubStandards(selectedMonthData), [selectedMonthData]);

    const handleDownloadPdf = async (ref) => {
        const element = ref.current;

        // Create a high-res canvas of the element
        const canvas = await html2canvas(element, {
            scale: 2, // higher scale = better quality
            useCORS: true, // allows external images like logos
        });

        const imageData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const imgWidth = pdfWidth;
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;

        let heightLeft = imgHeight;
        let position = 0;

        // Add first page
        pdf.addImage(imageData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;

        // Add extra pages if needed
        while (heightLeft > 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imageData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;
        }

        pdf.save("report.pdf");
    };

    useEffect(() => {
        if (!wisdomData) return;

        const months = wisdomData.total?.months || [];
        if (!months.length) return;

        // Months
        setDatasMonths(months);
        setSelectedMonthIdx(months.length - 1);

        // Arrange organizations
        const arrangedOrgs = Object.values(wisdomData.organizations || {})
            .sort((a, b) => b.overall - a.overall);

        const wisdomDataArray = [wisdomData.total, ...arrangedOrgs];

        setArrangedOrg(wisdomDataArray);
        setSelectedOrg((userInfo?.user_role === "Operations Excellence Lead" || userInfo?.user_role === "Super Admin" || userInfo?.user_role === "Wisdom Observer") ? wisdomDataArray[arrangedOrgIdx] : wisdomData.organizations[userInfo?.organization_id]);
    }, [wisdomData]);

    const selectedMonthRef = useRef(null);
    const prevYearRef = useRef(year);
    selectedMonthRef.current = selectedMonth;

    useEffect(() => {
        const setDefaultMonth = () => {
            // Keep the chosen month when only the organization changed (same year)
            const yearChanged = prevYearRef.current !== year;
            prevYearRef.current = year;
            const keepIdx = yearChanged ? -1 : datasMonths.findIndex(month => month?.monthNumber === selectedMonthRef.current?.monthNumber);
            if (keepIdx !== -1) {
                setSelectedMonthIdx(keepIdx);
                setSelectedMonth(datasMonths[keepIdx]);
                return;
            }

            const now = new Date();
            const currentMonth = year === 2026 ? now.getMonth() : 11;
            const currentMonthData = datasMonths.find(month => month.monthNumber === (currentMonth + 1));
            const findMonth = datasMonths.findIndex(month => month?.monthNumber === currentMonthData?.monthNumber);
            setSelectedMonthIdx(findMonth)
            setSelectedMonth(currentMonthData)
        }

        setDefaultMonth();
    }, [datasMonths, year])

    useEffect(() => {
        setFromDate("");
        setToDate("");
    }, [year]);

    const toggleMonth = (status) => {
        setFromDate("");
        setToDate("");
        if (status) {
            if (selectedMonthIdx !== datasMonths.length - 1) {
                setSelectedMonth(datasMonths[selectedMonthIdx + 1]);
                setSelectedMonthIdx(prev => prev + 1);
            }
        } else {
            if (selectedMonthIdx !== 0) {
                setSelectedMonth(datasMonths[selectedMonthIdx - 1]);
                setSelectedMonthIdx(prev => prev - 1);
            }
        }
    }

    useEffect(() => {
        const loadDataMonths = () => {
            if (selectedOrg) {
                setDatasMonths(selectedOrg?.months);
            }
        }

        loadDataMonths();
    }, [wisdomData, selectedOrg, selectedMonthIdx]);

    useEffect(() => {
        fetchCenters().then(async data => {
            if (data.centers && data.centers.length > 0) setSelectedCenter(data.centers[0]);
        });
    }, []);

    // organization search function
    const handleSelectOrganization = (orgName) => {
        const index = arrangedOrg.findIndex(org => org?.name === orgName);
        const selectedOrg = arrangedOrg[index];

        setArrangedOrgIdx(index);
        setSelectedOrg(selectedOrg);
        setSelectedOrgId(selectedOrg?.id);
    };

    const handleSubBenchMarkClick = (s) => {
        if (
            selectedOrg?.id !== "All" &&
            (userInfo?.organization_id === 13 || userInfo?.employee_role === "Academic Principal" || userInfo?.employee_role === "Executive Manager") &&
            s.code !== "T" &&
            s.code !== "C" &&
            s.code !== "WCP" &&
            s.code !== "W" &&
            s.code !== "EDU" &&
            s.code !== "sessions" &&
            s.code !== "STB" &&
            s.code !== "STA" &&
            s.code !== "DO" &&
            s.code !== "TG"
        ) {
            setSubDataDetails(s.code);
            setSubDataStatus(true);
        } else if (
            selectedOrg?.id !== "All" &&
            (userInfo?.organization_id === 13 || userInfo?.employee_role === "Academic Principal" || userInfo?.employee_role === "Executive Manager") &&
            s.code === "T"
        ) {
            setPopupPage("teacher dashboard");
        } else if (
            selectedOrg?.id !== "All" &&
            (userInfo?.organization_id === 13 || userInfo?.employee_role === "Academic Principal" || userInfo?.employee_role === "Executive Manager") &&
            s.code === "C"
        ) {
            setPopupPage("curriculum dashboard");
        } else if (
            selectedOrg?.id !== "All" &&
            (userInfo?.organization_id === 13 || userInfo?.employee_role === "Academic Principal" || userInfo?.employee_role === "Executive Manager") &&
            s.code === "WCP"
        ) {
            setPopupPage("wcp dashboard");
        } else if (
            selectedOrg?.id !== "All" &&
            (userInfo?.organization_id === 13 || userInfo?.employee_role === "Academic Principal" || userInfo?.employee_role === "Executive Manager") &&
            s.code === "W"
        ) {
            setPopupPage("work environment dashboard");
        } else if (
            selectedOrg?.id !== "All" &&
            (userInfo?.organization_id === 13 || userInfo?.employee_role === "Academic Principal" || userInfo?.employee_role === "Executive Manager") &&
            s.code === "EDU"
        ) {
            setPopupPage("educational environment dashboard");
        } else if (
            selectedOrg?.id !== "All" &&
            (userInfo?.organization_id === 13 || userInfo?.employee_role === "Academic Principal" || userInfo?.employee_role === "Executive Manager") &&
            s.code === "sessions"
        ) {
            setPopupPage("odbm dashboard");
            setOdbmPage("sessions");
        } else if (
            selectedOrg?.id !== "All" &&
            (userInfo?.organization_id === 13 || userInfo?.employee_role === "Academic Principal" || userInfo?.employee_role === "Executive Manager") &&
            s.code === "STA"
        ) {
            setPopupPage("odbm dashboard");
            setOdbmPage("STA");
        } else if (
            selectedOrg?.id !== "All" &&
            (userInfo?.organization_id === 13 || userInfo?.employee_role === "Academic Principal" || userInfo?.employee_role === "Executive Manager") &&
            s.code === "STB"
        ) {
            setPopupPage("odbm dashboard");
            setOdbmPage("STB");
        } else if (
            selectedOrg?.id !== "All" &&
            (userInfo?.organization_id === 13 || userInfo?.employee_role === "Academic Principal" || userInfo?.employee_role === "Executive Manager") &&
            s.code === "DO"
        ) {
            setPopupPage("odbm dashboard");
            setOdbmPage("DO");
        } else if (
            selectedOrg?.id !== "All" &&
            (userInfo?.organization_id === 13 || userInfo?.employee_role === "Academic Principal" || userInfo?.employee_role === "Executive Manager") &&
            s.code === "TG"
        ) {
            setPopupPage("student attendance dashboard");
        }
    }

    if (mainDataLoading || subDataLoading) return <LoadingScreen />;

    return (
        <div className="min-h-[100vh] w-[100vw] text-[#fff] overflow-hidden" style={{
            background: 'radial-gradient(ellipse at center, #0a183d 60%, #1a1a2e 100%)',
            fontFamily: 'Cairo, sans-serif',
            position: 'relative',
            padding: 0,
            boxSizing: 'border-box',
        }}>
            <ModelNaviagtionSideBar defaultOpen={false} />
            <WisdomDashboardNavbar wisdomData={wisdomData} selectedOrg={selectedOrg} setPopupPage={setPopupPage} setClassRoomDetailsPopup={setClassRoomDetailsPopup} handleSelectOrganization={handleSelectOrganization} />
            {/* Page Body: left - middle - right sections*/}
            <div className="w-full h-full md:h-[88vh] flex flex-col md:flex-row justify-between gap-2 relative box-border p-4">
                {/* Left Column */}
                <div className="w-full md:w-[28%] md:h-full flex flex-col justify-start gap-2 box-border">
                    {/* Overview */}
                    <WisdomDashboardOrganizationOverview wisdomData={wisdomData} selectedOrg={selectedOrg} generalInfo={generalInfo} selectedMonthIdx={selectedMonthIdx} handleSelectOrganization={handleSelectOrganization} />
                    {/* General Info */}
                    <WisdomDashboardGeneralInfo generalInfo={generalInfo} selectedOrg={selectedOrg} setShowUserProfilePopup={setShowUserProfilePopup} setSelectedUserRole={setSelectedUserRole} setSelectedUserId={setSelectedUserId} setShowWorkShopPopup={setShowWorkShopPopup} setSelectedWorkshopId={setSelectedWorkshopId} />
                </div>
                {/* Middle Column */}
                <DashboardMiddleColumn
                    wisdomData={wisdomData} selectedOrg={selectedOrg} selectedCenter={selectedCenter} selectedMonthIdx={selectedMonthIdx}
                    arrangedOrg={arrangedOrg} arrangedOrgIdx={arrangedOrgIdx} handleSelectOrganization={handleSelectOrganization}
                    setSelectedOrg={setSelectedOrg} setSelectedOrgId={setSelectedOrgId} setArrangedOrgIdx={setArrangedOrgIdx}
                    filteredSubjects={filteredSubjects} selectedSubject={selectedSubject} setSelectedSubject={setSelectedSubject}
                    filteredStages={filteredStages} selectedStage={selectedStage} setSelectedStage={setSelectedStage}
                    filteredSpecializations={filteredSpecializations} selectedSpecialization={selectedSpecialization} setSelectedSpecialization={setSelectedSpecialization}
                    fromDate={fromDate} setFromDate={setFromDate}
                    toDate={toDate} setToDate={setToDate}
                    loading={mainDataLoading || subDataLoading} mapIds={selectedOrg?.id === "All" ? [15, 49, 52, 53, 55, 56, 57, 58] : selectedOrg?.id || wisdomData?.total?.id}
                />
                {/* Right Column */}
                <div className="w-full md:w-[28%] md:h-full flex flex-col justify-start items-stretch gap-4" style={{
                    boxSizing: 'border-box',
                }}>
                    {/* top row */}
                    <WisdomDashboardGeneralNumbers wisdomData={wisdomData} selectedOrg={selectedOrg} setEmployeeAbsenceDashboardPopup={setEmployeeAbsenceDashboardPopup} filteredEmployeesAbsence={filteredEmployeesAbsence} />
                    {/* bottom row */}
                    <DashboardBenchmarks
                        orgSubStandards={orgSubStandards} handleSubBenchMarkClick={handleSubBenchMarkClick} selectedOrg={selectedOrg}
                        year={year} setYear={setYear} toggleMonth={toggleMonth} datasMonths={datasMonths} selectedMonth={selectedMonth} selectedMonthIdx={selectedMonthIdx}
                    />
                </div>
            </div>

            {/* sub data's detail popup */}
            <WisdomDashboardSubDataDetails
                isOpen={subDataDetails !== "" && subDataStatus}
                onClose={() => setSubDataDetails("")}
                onDetails={() => { setSubDataStatus(false); setFormDetails("hi"); }}
                selectedMonthIdx={selectedMonthIdx}
                toggleMonth={toggleMonth}
                selectedMonth={selectedMonth}
                datasMonths={datasMonths}
                arrangedOrg={arrangedOrg}
                arrangedOrgIdx={arrangedOrgIdx}
                orgStandards={orgStandards}
                orgSubStandards={orgSubStandards.map(org => org.subData?.find(sub => sub.code === subDataDetails)).find(sub => sub)}
                selectedOrg={selectedOrg}
                setSelectedFormCode={setSelectedFormCode}
                subjects={filteredSubjects}
                setSelectedSubject={setSelectedSubject}
                selectedSubject={selectedSubject}
                stages={filteredStages}
                setSelectedStage={setSelectedStage}
                selectedStage={selectedStage}
                specializations={filteredSpecializations}
                setSelectedSpecialization={setSelectedSpecialization}
                selectedSpecialization={selectedSpecialization}
                toDate={toDate}
                setToDate={setToDate}
                setFromDate={setFromDate}
                fromDate={fromDate}
            />
            <WatomsDashboardFormDetails
                isOpen={formDetails !== "" && selectedFormCode !== ""}
                onClose={() => setFormDetails("")}
                selectedOrg={selectedOrg}
                orgSubStandards={orgSubStandards.map(org => org.subData?.find(sub => sub.code === subDataDetails)).find(sub => sub)}
                selectedFormCode={selectedFormCode}
            />
            {showUserProfilePopup && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
                    <div className="relative bg-white rounded-lg shadow-xl max-h-[90vh] overflow-y-auto p-2">
                        {/* Close Button */}
                        <button
                            onClick={() => setShowUserProfilePopup(false)}
                            className="absolute top-3 right-3 text-gray-500 hover:text-black text-xl font-bold z-10"
                        >
                            ×
                        </button>

                        <UserProfileData userId={selectedUserId} role={selectedUserRole} />
                    </div>
                </div>
            )}
            {showWorkShopPopup && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
                    <div className="relative bg-white rounded-lg shadow-xl max-h-[90vh] overflow-y-auto p-2">
                        {/* Close Button */}
                        <button
                            onClick={() => setShowWorkShopPopup(false)}
                            className="absolute top-3 right-3 text-gray-500 hover:text-black text-xl font-bold z-10"
                        >
                            ×
                        </button>

                        <WorkShopDetails workshopId={selectedWorkshopId} />
                    </div>
                </div>
            )}
            {popupPage === "teacher dashboard" && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
                    <div className="relative bg-[#16233a] rounded-lg shadow-xl max-h-[90vh] overflow-y-auto p-2">
                        {/* Close Button */}
                        <button
                            onClick={() => setPopupPage("")}
                            className="absolute top-3 left-3 w-8 h-8 flex items-center justify-center pb-1 text-gray-500 hover:text-white text-xl font-bold z-10 border border-blue-400 rounded-md"
                        >
                            ×
                        </button>

                        <TeachersDashboard orgId={selectedOrg?.id} year={year} month={selectedMonthIdx} />
                    </div>
                </div>
            )}
            {popupPage === "curriculum dashboard" && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
                    <div className="relative bg-[#16233a] rounded-lg shadow-xl max-h-[90vh] overflow-y-auto p-2">
                        {/* Close Button */}
                        <button
                            onClick={() => setPopupPage("")}
                            className="absolute top-3 left-3 w-8 h-8 flex items-center justify-center pb-1 text-gray-500 hover:text-white text-xl font-bold z-10 border border-blue-400 rounded-md"
                        >
                            ×
                        </button>

                        <CurriculumDashboard orgId={selectedOrg?.id} year={year} month={selectedMonthIdx} />
                    </div>
                </div>
            )}
            {popupPage === "wcp dashboard" && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
                    <div className="relative bg-[#16233a] rounded-lg shadow-xl max-h-[90vh] overflow-y-auto p-2">
                        {/* Close Button */}
                        <button
                            onClick={() => setPopupPage("")}
                            className="absolute top-3 left-3 w-8 h-8 flex items-center justify-center pb-1 text-gray-500 hover:text-white text-xl font-bold z-10 border border-blue-400 rounded-md"
                        >
                            ×
                        </button>

                        <WCPDashboard orgId={selectedOrg?.id} year={year} month={selectedMonthIdx} />
                    </div>
                </div>
            )}
            {popupPage === "work environment dashboard" && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
                    <div className="relative bg-[#16233a] rounded-lg shadow-xl max-h-[90vh] overflow-y-auto p-2">
                        {/* Close Button */}
                        <button
                            onClick={() => setPopupPage("")}
                            className="absolute top-3 left-3 w-8 h-8 flex items-center justify-center pb-1 text-gray-500 hover:text-white text-xl font-bold z-10 border border-blue-400 rounded-md"
                        >
                            ×
                        </button>

                        <WorkEnvDashboard orgId={selectedOrg?.id} year={year} month={selectedMonthIdx} />
                    </div>
                </div>
            )}
            {popupPage === "educational environment dashboard" && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
                    <EduEnvDashboard orgId={selectedOrg?.id} year={year} month={selectedMonthIdx} onClose={() => setPopupPage("")} />
                </div>
            )}
            {popupPage === "odbm dashboard" && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
                    <ODBMDashboard orgId={selectedOrg?.id} year={year} month={selectedMonthIdx} onClose={() => setPopupPage("")} page={odbmPage} />
                </div>
            )}
            {popupPage === "student attendance dashboard" && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
                    <StudentAttendanceDashboard orgId={selectedOrg?.id} year={year} month={selectedMonthIdx} onClose={() => setPopupPage("")} />
                </div>
            )}
            {popupPage === "cro report 1" && (
                <div className="fixed inset-0 bg-black/60 flex flex-col overflow-y-auto justify-start gap-6 items-center z-50">
                    <button
                        onClick={() => setPopupPage("")}
                        className="absolute top-4 right-4 text-white bg-gray-700 hover:bg-gray-800 w-12 h-12 flex justify-center items-center text-2xl font-bold cursor-pointer z-50"
                    >
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                    <button
                        onClick={() => handleDownloadPdf(pdfRef)}
                        className="absolute top-4 right-20 text-white bg-gray-700 hover:bg-gray-800 w-12 h-12 flex justify-center items-center text-2xl font-bold cursor-pointer z-50"
                    >
                        <FontAwesomeIcon icon={faPrint} />
                    </button>
                    <CroReport pdfRef={pdfRef} selectedOrgId={selectedOrgId} selectedMonthIdx={selectedMonthIdx} />
                </div>
            )}
            {popupPage === "cro report 2" && (
                <div className="fixed inset-0 bg-black/60 flex flex-col overflow-y-auto justify-start gap-6 items-center z-50">
                    <button
                        onClick={() => setPopupPage("")}
                        className="absolute top-4 right-4 text-white bg-gray-700 hover:bg-gray-800 w-12 h-12 flex justify-center items-center text-2xl font-bold cursor-pointer z-50"
                    >
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                    <button
                        onClick={() => handleDownloadPdf(pdfRef2)}
                        className="absolute top-4 right-20 text-white bg-gray-700 hover:bg-gray-800 w-12 h-12 flex justify-center items-center text-2xl font-bold cursor-pointer z-50"
                    >
                        <FontAwesomeIcon icon={faPrint} />
                    </button>
                    <CroReport2 pdfRef2={pdfRef2} selectedOrgId={selectedOrgId} selectedMonthIdx={selectedMonthIdx} />
                </div>
            )}
            {employeeAbsenceDashboardPopup && filteredEmployeesAbsence.length !== 0 && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
                    <div className="relative bg-white rounded-lg shadow-xl max-h-[90vh] overflow-y-auto p-2">
                        {/* Close Button */}
                        <button
                            onClick={() => setEmployeeAbsenceDashboardPopup(false)}
                            className="absolute top-3 right-3 text-gray-500 hover:text-black text-xl font-bold z-10"
                        >
                            ×
                        </button>

                        <EmployeeAbsneceDashboard data={filteredEmployeesAbsence} />
                    </div>
                </div>
            )}
            {classRoomDetailsPopup && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
                    <div className="relative bg-white rounded-lg shadow-xl max-h-[90vh] overflow-y-auto p-2">
                        {/* Close Button */}
                        <button
                            onClick={() => setClassRoomDetailsPopup(false)}
                            className="absolute top-3 right-3 text-gray-500 hover:text-black text-xl font-bold z-10"
                        >
                            ×
                        </button>

                        <ClassRoomDetailsDashboard data={classRoomDetails} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default WisdomDashboard;